/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Edit from "@monsma/XDL/Icons/Edit";
import { css } from "styled-components";

export const editLink: LinkPresentationProps = {
    css: css`
        ${getProp("theme.link.defaultProps.css")};
        margin-top: 20px;
    `,
    icon: {
        iconProps: {
            src: Edit,
            size: 12,
            color: "common.ui5",
            css: css`
                margin-right: 5px;
            `,
        },
    },
};

export const addressTitleStyle: TypographyProps = {
    variant: "h5",
    css: css`
        margin-bottom: 15px;
    `,
};

export const addressWrapper: InjectableCss = {
    css: css`
        // min-height: 100%;
        padding: 20px;
        background: ${getColor("common.background")};
        border: 1px solid ${getColor("common.ui12")};
        border-radius: 4px;
        flex: 1;
        font-style: normal;
        width: 100%;

        @media print {
            background: unset;
            border-width: 0;
            padding: 0;
        }
    `,
};
